export const footerMoreLinks = {
  'mx-es': [
    {
      title: 'Más',
      items: [
        {
          href: 'https://mx.wingie.com/contacto/',
          title: 'Contacto',
        },
        {
          href: 'https://mx.wingie.com/preguntas-frecuentes/',
          title: 'Preguntas más frecuentes',
        },

        {
          href: 'https://mx.wingie.com/acerca-de-nosotros/',
          title: 'Sobre nosotros',
        },
        {
          href: 'https://mx.wingie.com/privacidad/',
          title: 'Privacidad',
        },
        {
          href: 'https://mx.wingie.com/terminos-y-condiciones/',
          title: 'Términos y condiciones de uso',
        },
        {
          href: 'https://mx.wingie.com/awards/',
          title: 'Premios',
        },
      ],
    },
  ],
  'mx-en': [
    {
      title: 'More',
      items: [
        {
          href: 'https://mx.wingie.com/en/contact/',
          title: 'Contact',
        },
        {
          href: 'https://mx.wingie.com/en/faq/',
          title: 'Frequently Asked Questions',
        },

        {
          href: 'https://mx.wingie.com/en/about-us/',
          title: 'About us',
        },
        {
          href: 'https://mx.wingie.com/en/privacy/',
          title: 'Privacy',
        },
        {
          href: 'https://mx.wingie.com/en/terms-and-conditions/',
          title: 'Terms and Conditions',
        },
        {
          href: 'https://mx.wingie.com/en/awards/',
          title: 'Awards',
        },
      ],
    },
  ],
  'mx-de': [
    {
      title: 'Mehr',
      items: [
        {
          href: 'https://mx.wingie.com/de/kontakt/',
          title: 'Kontakt',
        },
        {
          href: 'https://mx.wingie.com/de/faq/',
          title: 'Häufig gestellte Fragen - Wingie',
        },

        {
          href: 'https://mx.wingie.com/de/uber-uns/',
          title: 'Über uns',
        },
        {
          href: 'https://mx.wingie.com/de/datenschutz/',
          title: 'Datenschutz & Cookies',
        },
        {
          href: 'https://mx.wingie.com/de/allgemeine-geschaeftsbedingungen/',
          title: 'Allgemeine Geschäftsbedingungen',
        },
        {
          href: 'https://mx.wingie.com/de/awards/',
          title: 'Unsere Preise',
        },
      ],
    },
  ],
  'mx-ru': [
    {
      title: 'более',
      items: [
        {
          href: 'https://mx.wingie.com/ru/contact/',
          title: 'Контакты',
        },
        {
          href: 'https://mx.wingie.com/ru/faq/',
          title: 'Часто задаваемые вопросы',
        },

        {
          href: 'https://mx.wingie.com/ru/about-us/',
          title: 'О нас',
        },
        {
          href: 'https://mx.wingie.com/ru/privacy/',
          title: 'Конфиденциальность',
        },
        {
          href: 'https://mx.wingie.com/ru/terms-and-conditions/',
          title: 'Условия и положения',
        },
        {
          href: 'https://mx.wingie.com/ru/awards/',
          title: 'Награды',
        },
      ],
    },
  ],
  'mx-ar': [
    {
      title: 'أكثر',
      items: [
        {
          href: 'https://mx.wingie.com/ar/contact/',
          title: 'التواصل',
        },
        {
          href: 'https://mx.wingie.com/ar/faq/',
          title: 'الأسئلة المتكررة',
        },

        {
          href: 'https://mx.wingie.com/ar/about-us/',
          title: 'تعرّف علينا',
        },
        {
          href: 'https://mx.wingie.com/ar/privacy/',
          title: 'الخصوصية - وينجي',
        },
        {
          href: 'https://mx.wingie.com/ar/terms-and-conditions/',
          title: 'شروط الاستخدام',
        },
        {
          href: 'https://mx.wingie.com/ar/awards/',
          title: 'جوائزنا',
        },
      ],
    },
  ],
  'mx-it': [
    {
      title: 'Di più',
      items: [
        {
          href: 'https://mx.wingie.com/it/contact/',
          title: 'Contatto',
        },
        // {
        //     href: 'https://mx.wingie.com/it/faq/',
        //     title: 'Domande Frequenti',
        // },

        {
          href: 'https://mx.wingie.com/it/about-us/',
          title: 'Chi siamo',
        },
        {
          href: 'https://mx.wingie.com/it/privacy/',
          title: 'Privacy',
        },
        {
          href: 'https://mx.wingie.com/it/terms-and-conditions/',
          title: 'Termini e Condizioni',
        },
        {
          href: 'https://mx.wingie.com/it/awards/',
          title: 'Premi',
        },
      ],
    },
  ],
  'mx-fr': [
    {
      title: 'Plus',
      items: [
        {
          href: 'https://mx.wingie.com/fr/contact/',
          title: 'Contact',
        },
        // {
        //     href: 'https://mx.wingie.com/fr/faq/',
        //     title: 'Questions Fréquemment Posées',
        // },

        {
          href: 'https://mx.wingie.com/fr/about-us/',
          title: 'À propos de nous',
        },
        {
          href: 'https://mx.wingie.com/fr/privacy/',
          title: 'Confidentialité',
        },
        {
          href: 'https://mx.wingie.com/fr/terms-and-conditions/',
          title: 'Termes et Conditions',
        },
        {
          href: 'https://mx.wingie.com/fr/awards/',
          title: 'Prix',
        },
      ],
    },
  ],
  'mx-pt': [
    {
      title: 'Mais',
      items: [
        {
          href: 'https://mx.wingie.com/pt/contact/',
          title: 'Contato',
        },
        // {
        //     href: 'https://mx.wingie.com/pt/faq/',
        //     title: 'Perguntas Frequentes',
        // },

        {
          href: 'https://mx.wingie.com/pt/about-us/',
          title: 'Sobre nós',
        },
        {
          href: 'https://mx.wingie.com/pt/privacy/',
          title: 'Privacidade',
        },
        {
          href: 'https://mx.wingie.com/pt/terms-and-conditions/',
          title: 'Termos e Condições',
        },
        {
          href: 'https://mx.wingie.com/pt/awards/',
          title: 'Prémios',
        },
      ],
    },
  ],
  'mx-ro': [
    {
      title: 'Mai mult',
      items: [
        {
          href: 'https://mx.wingie.com/ro/contact/',
          title: 'Contact',
        },
        // {
        //     href: 'https://mx.wingie.com/ro/faq/',
        //     title: 'Întrebări Frecvente',
        // },

        {
          href: 'https://mx.wingie.com/ro/about-us/',
          title: 'Despre noi',
        },
        {
          href: 'https://mx.wingie.com/ro/privacy/',
          title: 'Confidențialitate',
        },
        {
          href: 'https://mx.wingie.com/ro/terms-and-conditions/',
          title: 'Termeni și Condiții',
        },
        {
          href: 'https://mx.wingie.com/ro/awards/',
          title: 'Premii',
        },
      ],
    },
  ],
  'mx-pl': [
    {
      title: 'Więcej',
      items: [
        {
          href: 'https://mx.wingie.com/pl/contact/',
          title: 'Kontakt',
        },
        // {
        //     href: 'https://mx.wingie.com/pl/faq/',
        //     title: 'Często Zadawane Pytania',
        // },

        {
          href: 'https://mx.wingie.com/pl/about-us/',
          title: 'O nas',
        },
        {
          href: 'https://mx.wingie.com/pl/privacy/',
          title: 'Prywatność',
        },
        {
          href: 'https://mx.wingie.com/pl/terms-and-conditions/',
          title: 'Warunki',
        },
        {
          href: 'https://mx.wingie.com/pl/awards/',
          title: 'Nagrody',
        },
      ],
    },
  ],
  'mx-lt': [
    {
      title: 'Daugiau',
      items: [
        {
          href: 'https://mx.wingie.com/lt/contact/',
          title: 'Kontaktai',
        },
        // {
        //     href: 'https://mx.wingie.com/lt/faq/',
        //     title: 'Dažnai Užduodami Klausimai',
        // },

        {
          href: 'https://mx.wingie.com/lt/about-us/',
          title: 'Apie mus',
        },
        {
          href: 'https://mx.wingie.com/lt/privacy/',
          title: 'Privatumas',
        },
        {
          href: 'https://mx.wingie.com/lt/terms-and-conditions/',
          title: 'Sąlygos',
        },
        {
          href: 'https://mx.wingie.com/lt/awards/',
          title: 'Prizai',
        },
      ],
    },
  ],
  'mx-uz': [
    {
      title: "Ko'proq",
      items: [
        {
          href: 'https://mx.wingie.com/uz/contact/',
          title: 'Aloqa',
        },
        // {
        //     href: 'https://mx.wingie.com/uz/faq/',
        //     title: "Ko'p Beriladigan Savollar",
        // },

        {
          href: 'https://mx.wingie.com/uz/about-us/',
          title: 'Biz haqimizda',
        },
        {
          href: 'https://mx.wingie.com/uz/privacy/',
          title: 'Maxfiylik',
        },
        {
          href: 'https://mx.wingie.com/uz/terms-and-conditions/',
          title: 'Shartlar',
        },
        {
          href: 'https://mx.wingie.com/uz/awards/',
          title: 'Mukofotlar',
        },
      ],
    },
  ],
  'mx-sr': [
    {
      title: 'Више',
      items: [
        {
          href: 'https://mx.wingie.com/sr/contact/',
          title: 'Контакт',
        },
        // {
        //     href: 'https://mx.wingie.com/sr/faq/',
        //     title: 'Често Постављана Питања',
        // },

        {
          href: 'https://mx.wingie.com/sr/about-us/',
          title: 'О нама',
        },
        {
          href: 'https://mx.wingie.com/sr/privacy/',
          title: 'Приватност',
        },
        {
          href: 'https://mx.wingie.com/sr/terms-and-conditions/',
          title: 'Услови',
        },
        {
          href: 'https://mx.wingie.com/sr/awards/',
          title: 'Награде',
        },
      ],
    },
  ],
  'mx-ky': [
    {
      title: 'Дагы',
      items: [
        {
          href: 'https://mx.wingie.com/ky/contact/',
          title: 'Байланыш',
        },
        // {
        //     href: 'https://mx.wingie.com/ky/faq/',
        //     title: 'Көп берилген суроолор',
        // },

        {
          href: 'https://mx.wingie.com/ky/about-us/',
          title: 'Биз жөнүндө',
        },
        {
          href: 'https://mx.wingie.com/ky/privacy/',
          title: 'Купуялык',
        },
        {
          href: 'https://mx.wingie.com/ky/terms-and-conditions/',
          title: 'Шарттар',
        },
        {
          href: 'https://mx.wingie.com/ky/awards/',
          title: 'Мурадлар',
        },
      ],
    },
  ],
  'mx-tg': [
    {
      title: 'Бештар',
      items: [
        {
          href: 'https://mx.wingie.com/tg/contact/',
          title: 'Тамос',
        },
        // {
        //     href: 'https://mx.wingie.com/tg/faq/',
        //     title: 'Саволҳои зиёд додашаванда',
        // },

        {
          href: 'https://mx.wingie.com/tg/about-us/',
          title: 'Дар бораи мо',
        },
        {
          href: 'https://mx.wingie.com/tg/privacy/',
          title: 'Махфият',
        },
        {
          href: 'https://mx.wingie.com/tg/terms-and-conditions/',
          title: 'Шартҳо',
        },
        {
          href: 'https://mx.wingie.com/tg/awards/',
          title: 'Мурадлар',
        },
      ],
    },
  ],
  'mx-kk': [
    {
      title: 'Көбірек',
      items: [
        {
          href: 'https://mx.wingie.com/kk/contact/',
          title: 'Байланыс',
        },
        // {
        //     href: 'https://mx.wingie.com/kk/faq/',
        //     title: 'Жиі қойылатын сұрақтар',
        // },

        {
          href: 'https://mx.wingie.com/kk/about-us/',
          title: 'Біз туралы',
        },
        {
          href: 'https://mx.wingie.com/kk/privacy/',
          title: 'Maxfiylik',
        },
        {
          href: 'https://mx.wingie.com/kk/terms-and-conditions/',
          title: 'Шарттар',
        },
        {
          href: 'https://mx.wingie.com/kk/awards/',
          title: 'Біздің марапаттарымыз',
        },
      ],
    },
  ],
  'mx-nl': [
    {
      title: 'Meer',
      items: [
        {
          href: 'https://mx.wingie.com/nl/contact/',
          title: 'Contact',
        },
        // {
        //     href: 'https://mx.wingie.com/nl/faq/',
        //     title: 'Veelgestelde Vragen',
        // },

        {
          href: 'https://mx.wingie.com/nl/about-us/',
          title: 'Over ons',
        },
        {
          href: 'https://mx.wingie.com/nl/privacy/',
          title: 'Privacy',
        },
        {
          href: 'https://mx.wingie.com/nl/terms-and-conditions/',
          title: 'Voorwaarden',
        },
        {
          href: 'https://mx.wingie.com/nl/awards/',
          title: 'Onze prijzen',
        },
      ],
    },
  ],
  'mx-ja': [
    {
      title: 'もっと',
      items: [
        { title: 'お問い合わせ', href: 'https://mx.wingie.com/ja/contact/' },
        { title: 'よくある質問', href: 'https://mx.wingie.com/en/faq/' },
        { title: '会社概要', href: 'https://mx.wingie.com/ja/about-us/' },
        { title: 'プライバシーポリシー', href: 'https://mx.wingie.com/ja/privacy/' },
        { title: '利用規約', href: 'https://mx.wingie.com/ja/terms-and-conditions/' },
        { title: '受賞歴', href: 'https://mx.wingie.com/ja/awards/' },
      ],
    },
  ],
  'mx-zh': [
    {
      title: '更多',
      items: [
        { title: '联系方式', href: 'https://mx.wingie.com/zh/contact/' },
        { title: '常见问题', href: 'https://mx.wingie.com/en/faq/' },
        { title: '关于我们', href: 'https://mx.wingie.com/zh/about-us/' },
        { title: '隐私政策', href: 'https://mx.wingie.com/zh/privacy/' },
        { title: '条款和条件', href: 'https://mx.wingie.com/zh/terms-and-conditions/' },
        { title: '我们的奖项', href: 'https://mx.wingie.com/zh/awards/' },
      ],
    },
  ],
  'mx-ko': [
    {
      title: '더보기',
      items: [
        { title: '연락처', href: 'https://mx.wingie.com/ko/contact/' },
        { title: '자주 묻는 질문', href: 'https://mx.wingie.com/en/faq/' },
        { title: '회사 소개', href: 'https://mx.wingie.com/ko/about-us/' },
        { title: '개인정보처리방침', href: 'https://mx.wingie.com/ko/privacy/' },
        { title: '이용약관', href: 'https://mx.wingie.com/ko/terms-and-conditions/' },
        { title: '수상 내역', href: 'https://mx.wingie.com/ko/awards/' },
      ],
    },
  ],
  'mx-hi': [
    {
      title: 'अधिक',
      items: [
        { title: 'संपर्क करें', href: 'https://mx.wingie.com/hi/contact/' },
        { title: 'सामान्य प्रश्न', href: 'https://mx.wingie.com/en/faq/' },
        { title: 'हमारे बारे में', href: 'https://mx.wingie.com/hi/about-us/' },
        { title: 'गोपनीयता', href: 'https://mx.wingie.com/hi/privacy/' },
        { title: 'नियम और शर्तें', href: 'https://mx.wingie.com/hi/terms-and-conditions/' },
        { title: 'हमारे पुरस्कार', href: 'https://mx.wingie.com/hi/awards/' },
      ],
    },
  ],
  'mx-ta': [
    {
      title: 'மேலும்',
      items: [
        { title: 'தொடர்பு', href: 'https://mx.wingie.com/ta/contact/' },
        { title: 'அடிக்கடி கேட்கப்படும் கேள்விகள்', href: 'https://mx.wingie.com/en/faq/' },
        { title: 'எங்கள் பற்றி', href: 'https://mx.wingie.com/ta/about-us/' },
        { title: 'தனியுரிமை', href: 'https://mx.wingie.com/ta/privacy/' },
        { title: 'விதிமுறைகள்', href: 'https://mx.wingie.com/ta/terms-and-conditions/' },
        { title: 'எங்கள் விருதுகள்', href: 'https://mx.wingie.com/ta/awards/' },
      ],
    },
  ],
  'mx-th': [
    {
      title: 'เพิ่มเติม',
      items: [
        { title: 'ติดต่อเรา', href: 'https://mx.wingie.com/th/contact/' },
        { title: 'คำถามที่พบบ่อย', href: 'https://mx.wingie.com/en/faq/' },
        { title: 'เกี่ยวกับเรา', href: 'https://mx.wingie.com/th/about-us/' },
        { title: 'นโยบายความเป็นส่วนตัว', href: 'https://mx.wingie.com/th/privacy/' },
        { title: 'ข้อกำหนดและเงื่อนไข', href: 'https://mx.wingie.com/th/terms-and-conditions/' },
        { title: 'รางวัลของเรา', href: 'https://mx.wingie.com/th/awards/' },
      ],
    },
  ],
  'mx-ur': [
    {
      title: 'مزید',
      items: [
        { title: 'رابطہ کریں', href: 'https://mx.wingie.com/ur/contact/' },
        { title: 'عمومی سوالات', href: 'https://mx.wingie.com/en/faq/' },
        { title: 'ہمارے بارے میں', href: 'https://mx.wingie.com/ur/about-us/' },
        { title: 'رازداری', href: 'https://mx.wingie.com/ur/privacy/' },
        { title: 'شرائط و ضوابط', href: 'https://mx.wingie.com/ur/terms-and-conditions/' },
        { title: 'ہمارے اعزازات', href: 'https://mx.wingie.com/ur/awards/' },
      ],
    },
  ],
  'mx-ka': [
    {
      title: 'მეტი',
      items: [
        { title: 'კონტაქტი', href: 'https://mx.wingie.com/ka/contact/' },
        { title: 'ხშირად დასმული კითხვები', href: 'https://mx.wingie.com/en/faq/' },
        { title: 'ჩვენ შესახებ', href: 'https://mx.wingie.com/ka/about-us/' },
        { title: 'კონფიდენციალურობა', href: 'https://mx.wingie.com/ka/privacy/' },
        { title: 'წესები და პირობები', href: 'https://mx.wingie.com/ka/terms-and-conditions/' },
        { title: 'ჩვენი ჯილდოები', href: 'https://mx.wingie.com/ka/awards/' },
      ],
    },
  ],
}
